"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdjustedTimezone = void 0;
const constants_1 = require("@daytrip/constants");
/**
 * Returns timezone adjusted based on the TIMEZONE_MAP const.
 * We do the adjustment for two reasons:
 * 1. mapping new timezones not yet supported by our Node version to older timezones so date-fns-tz package does not fail (no mapping currently)
 * 2. mapping timezones returned by geo-tz package to timezones expected by Intl
 * @param timezone timezone to adjust
 * @returns adjusted timezone
 */
function getAdjustedTimezone(timezone) {
    if (timezone in constants_1.TIMEZONE_MAP) {
        return constants_1.TIMEZONE_MAP[timezone];
    }
    return timezone;
}
exports.getAdjustedTimezone = getAdjustedTimezone;
//# sourceMappingURL=getAdjustedTimezone.js.map